import { lazy } from 'react';

const miscRoutes = [
    {
        exact: true,
        path: '/newuser',
        component: lazy(() => import('../views/NegativeFlow/NegativeFlow/NewUserDashboard'))
    },
    {
        exact: true,
        path: '/dialog',
        component: lazy(() => import('../dialogs/DemoPage'))
    },
    {
        exact: true,
        path: '/refueler',
        component: lazy(() => import('../views/Refueler'))
    },
    {
        exact: true,
        path: '/codingPlayground',
        component: lazy(() => import('../views/codingPGround/Coding'))
    }
];

export default miscRoutes;
